import { put, all, takeEvery, fork, select, call } from "redux-saga/effects";

import * as R from "ramda";

import { apiCall } from "App/Data/sagas";

import { actions as TabsActions } from "ui-kit/Tabs";

import { actions } from "./model";

import {
  TABS,
  HOME_TASK_CARD_TABS_INSTANCE_ID
} from "Portal/NewPortal/Sections/Home/Cards/Tasks/constants";

import { registerError } from "redux/modules/errors/actions";

import { eventDetails as getEventDetails } from "redux/modules/portal/selectors";

import { portalUser as getPortalUser } from "redux/modules/portal/user/selectors";

const init = function*() {
  // load details

  yield put(
    TabsActions.setSelectedTab(TABS.ALL, {
      meta: {
        instanceId: HOME_TASK_CARD_TABS_INSTANCE_ID
      }
    })
  );
};

const resolvePortalMeta = function*() {
  const portalUser = yield select(getPortalUser);

  const contactId = R.pathEq(["active_view", "type"], "user", portalUser)
    ? R.pathOr(undefined, ["active_view", "contact_id"], portalUser)
    : undefined;

  const accountId = R.pathEq(["active_view", "type"], "account", portalUser)
    ? R.pathOr(undefined, ["active_view", "id"], portalUser)
    : undefined;

  return {
    contactId,
    accountId,
    recordId: accountId ? accountId : contactId
  };
};

const addFollowupFormSubmission = function*({
  payload: {
    data: { id },
    taskSessionId
  }
}) {
  const eventDetails = yield select(getEventDetails);

  try {
    const { recordId } = yield call(resolvePortalMeta);
    const { payload: submission } = yield call(apiCall, {
      method: "post",
      url: `/followup-forms/event/${eventDetails.id}/forms/${id}/submissions`,
      data: {
        recordId: taskSessionId ? taskSessionId : recordId
      }
    });

    return submission;
  } catch (e) {
    yield put(
      registerError([
        {
          system: e,
          user: "An error occurred adding a follow-up form submission"
        }
      ])
    );
  }

  return {};
};

const followupForm = function*({ payload }) {
  try {
    const submission = yield call(addFollowupFormSubmission, { payload });
    if (submission && submission.id) {
      window.location = `/followup-forms/${payload.data.form_slug}/${payload.data.id}/submissions/${submission.id}/enabledNewPortal/true`;
    }
  } catch (e) {
    yield put(
      registerError([
        {
          system: e,
          user: "An error occurred adding a follow-up form submission"
        }
      ])
    );
  }
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const watchFollowupForm = function*() {
  yield takeEvery(actions.followupForm.type, followupForm);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchFollowupForm)]);
};

export default rootSaga;
